var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-xs-right"},[_c('payment-brand',{attrs:{"brand":_vm.brand,"size":32}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }